import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {AppUserProgettiDTO, AppUserProgettiDTOApiResponse, VersOre2, VersOreDTO2ApiResponse,DeleteVersOre2Params} from "./types";
import {
    columnFiltersParamWithDateRange,
    columnFiltersParamWithDateRange2,
    sortingParam,
    sortingParam2
} from "../../common/Services";
import {Buffer} from "buffer";
import {format} from "date-fns";
import * as Yup from "yup";


const moment = require('moment')

export function useGetVersOreDTO2(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
     duplicati: number,
 ) {
    return useQuery<VersOreDTO2ApiResponse>({
        queryKey: [
            'fetchVersOreDTO2',
            columnFilters,
            globalFilter,
            pagination.pageIndex,
            pagination.pageSize,
            sorting,
            duplicati,
        ],
        queryFn: async () => {

            let coddip = localStorage.getItem('coddip') || '';
            const keyrole = localStorage.getItem('keyrole') || '';

            const isAdmin =  keyrole.includes('TimeReportAdmin') ;

            const myLimit=pagination.pageSize
            const myOffset =
                pagination.pageIndex === 0
                    ? '0'
                    : `${pagination.pageSize * pagination.pageIndex}`;

            let myURL = `?limit=${myLimit}&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange2(
                columnFilters
            )}&ordering=${sortingParam2(sorting)}`;




            if (!isAdmin) {
                        myURL += `&coddip=${coddip}`;
                }

            if (duplicati !== undefined) {
                  myURL += `&duplicati=${duplicati}`;
                }

            // console.log('myURL',myURL);

            const response = await AxiosInstance.get(`versoredto2/${myURL}`);

            return response.data;
        },
        refetchOnWindowFocus: false,
    });
}



export function useGetVersOre2(id: number) {
  return useQuery<VersOre2>({
    queryKey: ['fetchVersOre2', id],
    queryFn: async () => {
      const response = await AxiosInstance.get('versore2/' + id + '/');


      const transformedData = response.data?.data?.VersOre2;



      return transformedData;
    },
    refetchOnWindowFocus: false,
  });
}






export function useCreateVersOre2() {
  const queryClient = useQueryClient();
  return useMutation({

    mutationFn: async (versore: VersOre2) => {
      if (versore.datareg) {
        versore.datareg = moment(versore.datareg).format('YYYY-MM-DD');
      }

      if (versore.datains) {
        versore.datains = moment(versore.datains).format('YYYY-MM-DD');
      }

      if (versore.inizlav) {

        versore.inizlav = moment(versore.inizlav).format('YYYY-MM-DDTHH:mm');

      }

      if (versore.finelav) {
        versore.finelav = moment(versore.finelav).format('YYYY-MM-DDTHH:mm');
      }

        // console.log('add versore', versore);

       const response = await AxiosInstance.post('versore2/0/',versore);
       return response.data;

      // return AxiosInstance.post('versore/0/',mapVersOreToJson(versore));
    },

     onSuccess: async (data, variables) => {

        // console.log('data returned insert' ,data);

        const op = 'INS';

  const dittaorig = data?.data?.VersOre2?.ditta;
  const progorig = data?.data?.VersOre2?.codprog;
  const nrrelorig = data?.data?.VersOre2?.id;

         // console.log(op,dittaorig,progorig,nrrelorig)

        if (op && dittaorig && progorig && nrrelorig) {
            //console.log(op,dittaorig,nrrelorig)
            await versOreDup({ op, dittaorig, progorig, nrrelorig });
       }

       queryClient.invalidateQueries({ queryKey: ['fetchVersOreDTO2'] });

   }, //refetch VersoOre after mutation, disabled for demo
     });
}

 export function useUpdateVersOre2() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (versore: VersOre2) => {
      if (versore.datareg) {
        versore.datareg = moment(versore.datareg).format('YYYY-MM-DD');
      }
      if (versore.datains) {
        versore.datains = moment(versore.datains).format('YYYY-MM-DD');
      }
      if (versore.inizlav) {
        versore.inizlav = moment(versore.inizlav).format('YYYY-MM-DDTHH:mm');
      }

      if (versore.finelav) {
        versore.finelav = moment(versore.finelav).format('YYYY-MM-DDTHH:mm');
      }



        const response = await AxiosInstance.patch('versore2/'+versore.id+'/',versore);
        return response.data;
    },
    onSuccess: async (data, variables) => {
      // console.log('data returned update', data)
      const op = 'UPD';

  const dittaorig = data?.data?.VersOre2?.ditta;
  const progorig = data?.data?.VersOre2?.codprog;
  const nrrelorig = data?.data?.VersOre2?.id;

      if (op && dittaorig && progorig && nrrelorig) {
        await versOreDup({ op, dittaorig, progorig, nrrelorig });
      }

      queryClient.invalidateQueries({ queryKey: ['fetchVersOreDTO2'] });
      queryClient.invalidateQueries({ queryKey: ['fetchReportAgentiVersore'] });
    },
  });
}



export function useDeleteVersOre2() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: DeleteVersOre2Params) => {
      await AxiosInstance.delete(`versore2/${id}/`);
    },

    onSuccess: async (_, variables) => {
      const { dittaorig, progorig, nrrelorig } = variables;

      await versOreDup({
        op: "DEL",
    dittaorig: String(dittaorig),
    progorig: String(progorig),
    nrrelorig: String(nrrelorig),
      });

      queryClient.invalidateQueries({
        queryKey: ["fetchVersOreDTO2"],
      });
    },
  });
}





export function useGetAppUserProgettiDTO(idprog: string, coddip: string) {
  return useQuery<AppUserProgettiDTOApiResponse>({
    queryKey: ['fetchAppUserProgettiDTO', idprog, coddip],
    queryFn: async () => {
      const response = await AxiosInstance.get(
        `appuserprogettidto/?limit=10000&offset=0&idprog=${idprog}&coddip=${coddip}`
      );
      return response.data;
    },
    enabled: !!idprog && !!coddip,
    refetchOnWindowFocus: false,
  });
}

export async function versOreDup({ op, dittaorig, progorig, nrrelorig }: { op: string; dittaorig: string; progorig: string; nrrelorig: string }) {
  try {

    const response = await AxiosInstance.get('versoredup', {
      params: { op, dittaorig,progorig, nrrelorig }
    });
    // console.log('Duplication response:', response.data);
    // Return the response data
    return response.data;
  } catch (error) {
    // Handle errors, log them, or rethrow if necessary
    console.error('Error during duplication:', error);
    throw new Error('Duplication failed');
  }
}

export async function jasperVersoreBlob( fromDate: Date, toDate: Date, formato: String) {
  try {
    const username = 'jasperadmin';
    const password = 'Tibco2024@';
    const base64encodedData = Buffer.from(`${username}:${password}`).toString('base64');

    const fromDateString = fromDate ? format(fromDate, 'yyyy-MM-dd') : '';
    const toDateString = toDate ? format(toDate, 'yyyy-MM-dd') : '';

         let pag = '';
             if (formato === 'xlsx') {
                pag = 'ignorePagination=true&'
            }


    const response = await fetch(`${BASE_URL_JASPERSERVER}/rest_v2/reports/reports/repversore${formato}.${formato}?${pag}datainizio=${fromDateString}&datafine=${toDateString}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/'+formato,
        'Authorization': `Basic ${base64encodedData}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch the report');
    }

    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error('Error generating report:', error);
    throw error; // Rethrow the error to handle it in the calling code if needed
  }
};

export async function fnAlertPrep(codprog: String) {
  try {
    const response = await AxiosInstance.get(
      `fnalertprep/${codprog}/`
    );

    return response.data;

  } catch (error) {
    console.error('Error calculating Alert Prep:', error);
    throw new Error('Alert Prep failed');
  }
}

export type VersOreCopilotRewriteRequest = {
  rewriteType: string;
  maxChars: number;
  inputText: string;
  rewritePrompt: string;
};

export type VersOreCopilotRewriteResponse = {
  text: string;
  clipped: boolean;
  maxChars: number;
  rewriteType: string;
};

export async function rewriteVersOreNoteWithCopilotApi(
  payload: VersOreCopilotRewriteRequest
): Promise<VersOreCopilotRewriteResponse> {
  const response = await AxiosInstance.post('versore/copilot-rewrite/', {
    rewrite_type: payload.rewriteType,
    max_chars: payload.maxChars,
    input_text: payload.inputText,
    rewrite_prompt: payload.rewritePrompt,
  });

  const data = response?.data?.data || {};

  return {
    text: String(data.text || ''),
    clipped: Boolean(data.clipped),
    maxChars: Number(data.max_chars || payload.maxChars),
    rewriteType: String(data.rewrite_type || payload.rewriteType),
  };
}



export const validationSchemaVersOre2 = Yup.object().shape({
    datareg: Yup.date()
        .nullable()
        .transform((value, originalValue) => {
            if (originalValue === "") {
                return undefined;
            }
            return value;
        })
        .typeError("Data deve essere una data valida"),
    datains: Yup.date()
        .nullable()
        .transform((value, originalValue) => {
            if (originalValue === "") {
                return undefined;
            }
            return value;
        })
        .typeError("Data deve essere una data valida"),
        id: Yup.number(),
        variante: Yup.string().nullable(),
        idprog: Yup.string().required("Il Progetto è obbligatorio"),
        idnodo: Yup.string().required("Il Nodo è obbligatorio"),
        idatt: Yup.string().required("L'attività è obbligatoria"),
        oreord: Yup.number().required("Le ore sono obbligatorie").typeError("Ore deve essere un numero").moreThan(0, "Ore/Min devono essere maggiori di 0"),
        // minord: Yup.number().required("I minuti sono obbligatori"),
        opzione: Yup.string(),
        note: Yup.string().required("Le note sono obbligatorie"),
        km: Yup.number().typeError("Km deve essere un numero"),
        trasf: Yup.number().typeError("Trasf deve essere un numero"),
        luogo: Yup.string().required("Il luogo è obbligatorio"),
        orestraord: Yup.number().typeError("Ore deve essere un numero"),
        minstraord: Yup.number().required("I minuti sono obbligatori"),

    });